export type TokenGetter = () => Promise<string | null>
export type StringGetter = () => string | null

let tokenGetter: TokenGetter | null = null
let tenantIdGetter: StringGetter | null = null
let userIdGetter: StringGetter | null = null
let planGetter: StringGetter | null = null

export const setTokenGetter = (getter: TokenGetter): void => {
  tokenGetter = getter
}

export const setTenantIdGetter = (getter: StringGetter): void => {
  tenantIdGetter = getter
}

export const setUserIdGetter = (getter: StringGetter): void => {
  userIdGetter = getter
}

export const setPlanGetter = (getter: StringGetter): void => {
  planGetter = getter
}

export const getAuthToken = async (): Promise<string | null> => {
  if (!tokenGetter) {
    return null
  }
  return await tokenGetter()
}

export const getTenantId = (): string | null => {
  if (!tenantIdGetter) {
    return null
  }
  return tenantIdGetter()
}

export const getUserId = (): string | null => {
  if (!userIdGetter) {
    return null
  }
  return userIdGetter()
}

export const getPlan = (): string | null => {
  if (!planGetter) {
    return null
  }
  return planGetter()
}

export const clearTokenGetter = (): void => {
  tokenGetter = null
}

export const clearAllGetters = (): void => {
  tokenGetter = null
  tenantIdGetter = null
  userIdGetter = null
  planGetter = null
}
